import React from 'react'
import { useSelector } from 'react-redux'
import validationConfig from './validationConfig'
import CustomCollapse from '../../CustomCollapse'
import CheckIcon from '../../../../assets/icons/check-icon.svg'
import ErrorIcon from '../../../../assets/icons/exclamation-icon.svg'
import FormValidators from '../../../../helpers/FormValidators'
import { MultiSelectField } from '../../FormFields'

const EnvironmentInfoForm = ({ formState, disabled }) => {
  // ===== Form state =====
  const { formData, formErrors, onFormDataChanged, validateFormField } = formState

  // ===== Redux state =====
  const allPlatforms = useSelector(({ lookupData }) => lookupData.allPlatforms)

  //  ===== Methods =====
  const onChange = (key, value) => {
    onFormDataChanged(key, value)
    validateFormField(key, value, validationConfig)
  }

  return (
    <CustomCollapse
      title="Environment information"
      icon={FormValidators.checkFormValidity(formErrors, validationConfig) ? CheckIcon : ErrorIcon}
    >
      <MultiSelectField
        displayName="Requested Platforms"
        placeholder="Select Platforms"
        description="The platforms which was requested to publish this application"
        onChange={(value) => onChange("requestPlatformCodes", value)}
        errorMessage={formErrors["requestPlatformCodes"]?.message}
        options={Array.isArray(allPlatforms) ? allPlatforms : []}
        value={formData["requestPlatformCodes"]}
        disabled={disabled}
      />
    </CustomCollapse>
  )
}

export default EnvironmentInfoForm
